<template>
  <div class="furikyuu">
    <h3>振休・振出申請</h3>
    <template v-if="furikyuu?.syukkin_date">
      <div class="col-item">
        <b class="title">出勤日</b>
        <p v-if="furikyuu?.syukkin_date">{{ divFurideStr(furikyuu?.syukkin_furidetani_type) }}</p>
        <p>{{ furikyuu?.syukkin_date }}</p>
      </div>
      <div class="col-item">
        <b class="title">就業場所</b>
        <p>{{ form.syuugyou_basyo_name }}</p>
      </div>
      <div class="col-item">
        <b class="title">出勤時間</b>
        <p v-if="furikyuu?.syukkin_date">{{ furikyuu?.start_time }}　～　{{ furikyuu?.end_time }}</p>
      </div>
      <div class="col-item">
        <b class="title">休憩時間</b>
        <p>{{ furikyuu?.kyuukei_time }}</p>
      </div>
    </template>

    <div class="col-item" v-if="furikyuu?.furikyuu1_date || furikyuu?.furikyuu2_date">
      <b class="title">振休取得日</b>
      <div class="detail-table">
        <div class="table-item" v-if="furikyuu?.furikyuu1_date">
          <p>{{ divStr(furikyuu?.furikyuutani1_type) }}</p>
          <p>{{ furikyuu?.furikyuu1_date }}</p>
        </div>
        <div class="table-item" v-if="furikyuu?.furikyuu2_date">
          <p>{{ divStr(furikyuu?.furikyuutani2_type) }}</p>
          <p>{{ furikyuu?.furikyuu2_date }}</p>
        </div>
      </div>
    </div>

    <div class="col-item">
      <b class="title">就業場所</b>
      <p>{{ form.syuugyou_basyo_name }}</p>
    </div>

    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { useForm } from '@/composable/form/form';
import OptionConst from '@/const/Option';
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup(props) {

    const furikyuu = props.form.furikyuu;

    // エラー取得
    const { getError } = useForm();

    const divFurideStr = (val: number | null | undefined) => {
      return OptionConst.SHINSEI_DIV_FURIDE_OPTION.find(opt => opt.val === val)?.label
    }

    const divStr = (val: number | null | undefined) => {
      return OptionConst.SHINSEI_DIV_OPTION.find(opt => opt.val === val)?.label
    }

    return {
      furikyuu,
      getError,
      divFurideStr,
      divStr,
      'kyuukaDiv': OptionConst.SHINSEI_DIV_OPTION,
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>
